import { render } from "./article-plat-add.vue?vue&type=template&id=b15ab55a&scoped=true&ts=true"
import script from "./article-plat-add.vue?vue&type=script&lang=ts"
export * from "./article-plat-add.vue?vue&type=script&lang=ts"

import "./article-plat-add.vue?vue&type=style&index=0&id=b15ab55a&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b15ab55a"]])

export default __exports__